export default {
  guides: {
    sectionTitle: "Guides détaillés USFans",
    sectionSubtitle: "Dix guides pratiques couvrant tout, des achats en toute sécurité à la livraison, aux coupons, à la légitimité et à la confidentialité.",
    readMore: "Lire le guide",
    items: [
      {
        title: "Guide d'achat USFans : acheter en toute confiance",
        desc: "Un parcours étape par étape pour naviguer sur USFans, choisir le bon produit et finaliser un achat en toute sécurité.",
      },
      {
        title: "Tableur USFans : le guide complet",
        desc: "Comprenez ce qu'est le tableur USFans, comment fonctionnent ses catégories et comment y naviguer rapidement.",
      },
      {
        title: "Avis USFans : fonctionnalités, avantages et inconvénients",
        desc: "Un regard honnête sur les fonctionnalités de la plateforme, ses avantages, ses limites et les points à surveiller.",
      },
      {
        title: "Frais de livraison USFans : guide complet des prix",
        desc: "Découvrez quels facteurs influencent les prix de livraison et comment estimer les coûts pour votre région.",
      },
      {
        title: "Coupon USFans : comment trouver de vraies offres",
        desc: "Un guide pratique pour trouver des promotions authentiques et comprendre le fonctionnement des coupons USFans.",
      },
      {
        title: "Code promo USFans : comment vérifier les offres",
        desc: "Comment vérifier la validité d'un code promo avant le paiement et éviter les offres expirées ou fausses.",
      },
      {
        title: "Entrepôt USFans : guide stockage et expédition",
        desc: "Tout ce qu'il faut savoir sur le stockage, le traitement des commandes et les délais de livraison.",
      },
      {
        title: "USFans est-il légitime ? À savoir avant d'acheter",
        desc: "Comment évaluer la légitimité, la confiance et les signaux de sécurité avant de passer commande.",
      },
      {
        title: "Sécurité USFans : protégez votre compte et vos données",
        desc: "Des recommandations pratiques pour sécuriser votre compte, vos paiements et vos informations personnelles.",
      },
      {
        title: "Confidentialité USFans : comment vos données sont gérées",
        desc: "Un aperçu clair des considérations de confidentialité et de la protection de vos données lors de vos achats.",
      },
    ],
    detail: {
      pointsTitle: "Ce qu'il faut retenir",
      points: [
        "Vérifiez toujours les prix, tailles et disponibilités actuels sur la boutique principale avant d'acheter.",
        "Consultez les frais de livraison et la livraison estimée pour votre région.",
        "Confirmez tout coupon ou code promo directement au paiement avant de vous y fier.",
        "Utilisez des sources officielles ou fiables et protégez vos informations personnelles et de paiement.",
      ],
      relatedTitle: "Plus de guides USFans",
      visitMain: "Visiter le site principal",
      backHome: "Retour à l'accueil",
    },
  },
};